<template>
  <div>
    <case-search-form :caseStatus="caseStatus"></case-search-form>
    <case-table :caseStatus="caseStatus"></case-table>
  </div>
</template>

<script>
import CaseSearchForm from "./case-search-form";
import CaseTable from "./case-table";
export default {
  components: {
    CaseSearchForm,
    CaseTable
  },
  data() {
    return {
      caseStatus: null
    }
  },
  created() {
    console.log("审批的status:",this.$route.meta.status);
    this.caseStatus = this.$route.meta.status
  }
}
</script>
<style scoped>

</style>